import { render, staticRenderFns } from "./BannersSegment.vue?vue&type=template&id=3f1faeda&"
import script from "./BannersSegment.vue?vue&type=script&lang=js&"
export * from "./BannersSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports